export var theme = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        padding: '0 24px',
        transition: 'all 0.3s ease-in-out',
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        rowGap: 4,
        position: 'relative',
        transition: 'all 0.3s ease-in-out',
    },
};
